<form focusOnError (ngSubmit)="ProcedToPay(bookForm.form.valid)" #bookForm="ngForm" novalidate id="bookForm">
  <div class="pax-mob-header">
    <div class="header-content-0 ">

      <div class="d-flex align-items-center gap-3 header-content-1">
        <img class="back-arrow" src="./assets/img/back-arrow.svg" alt="">
        <div class="text-box">
          <div class="font-18 font-500">
            Hotel Review
          </div>

        </div>
      </div>

    </div>
  </div>
  <!-- content section -->
  <!-- Booking Btn -->
  <div class="footer-container-pax">
    <div class="booking-footer">
      <div>
        <div class="total-label">Grand Total</div>
        <div class="total-amount">₹12,167 <i class="bi bi-info-circle"></i></div>
      </div>
      <button class="btn btn-booking">Continue Booking</button>
    </div>
  </div>
  <!-- End Of booking Btn -->

  <div class="container mt-4 main-div-mob">
    <div class="row mob-hide">
      <div class="d-flex justify-content-between">
        <div class="breadcrumb">

          <ol>
            <li class="rev Review ac">1. Review and Travellers </li>
            <li><span class="bdr-arr"></span></li>
            <li class="rev1">2. Payment</li>
          </ol>

        </div>
        <div class="timer">
          <div class="timer-container">
            <img src="assets/images/Icon/timer-icon.png" alt="Hourglass Icon" class="timer-icon">
            <div class="progress-container">
              <div class="progress-text">Time Left: {{display}}</div>
              <div class="progress-bar">
                <div class="progress"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="row">
      <!-- Left Column -->
      <div class="col-lg-9">


        <!-- Flight Details -->
        <div class="traveller-card-cust-pax mb-5">

          <div class="traveller-header-cust-pax d-flex align-items-center justify-content-between">
            <div class="header-1"><i class="fa-solid fa-plane-departure"></i> Hotel Review</div>
          </div>
          <div class="col-12 d-flex justify-content-between align-items-center pb-3 flex-wrap">
            <div>
              <h5 class="mb-1 fw-bold hotel-name">
                {{hotelDetails.Name}}                
                <span class="str-rw">
                  <i *ngFor="let star of ' '.repeat(hotelDetails.Star).split('')" class="fas fa-star"></i>
                </span>
                <!--<span class="badge border text-primary fw-normal">Hotel</span>-->
              </h5>
              <p class="text-muted mb-0 hotel-map-location">
                <i class="fas fa-map-location-dot"></i> {{hotelDetails.DisplayAdd}}
              </p>
            </div>
            <div class="text-end d-flex">
              <div class="end-rt-ratings">
                <div class="fw-semibold text1">Very Good</div>
                <small class="text-muted text2">6203 reviews</small>
              </div>
              <div class="text-white rt-ratings-number">4.6</div>
            </div>

          </div>

          <div class="p-3 ">
            <div class="flight-card-pax-fl-det">
              <div class="result-item">
                <div class="row hotel-box">
                  <!-- Hotel Image Section -->
                  <div class="col-md-4 hotel-image">
                    <div class="mrel">
                      <!--<div *ngIf="hotel.Offer=='Y'" class="htl_offer"><img src="/assets/images/HTLoffer.png"></div>
                      <div *ngIf="hotel.Refundablenfo != null && hotel.Refundablenfo != '' " class="Overlay__TopLeft HeroImage__CombinedBadgeContainer">
                        <div class="sc-bdfBwQ gNRfUM sc-JAcuL eKGqnO DefaultBadge DefaultBadge--OptionIncluded">
                          <div>
                            <span>{{hotel.Refundablenfo}}</span>
                          </div>
                        </div>
                      </div>-->
                      <div class="top_deal posab_dd"><span>DEAL OF THE DAY</span></div>
                      <div class="big_img">
                        <div>
                          <img [src]="hotelDetails.Image" onError="this.src='/assets/images/hotel/not_avil.jpg'" class="listImage" style="background-image: url(assets/images/image-1.jpg); background-size: 100%;">
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Hotel Info Section -->
                  <div class="col-md-8 content-dtl">
                    <div class="chk-tmng pax-dt">
                      <div class="chk-tmng-one">
                        <label><b>Check In</b></label>
                        <span>{{searchRequest.CheckIn}}</span>
                      </div>
                      <div class="chk-tmng-two">
                        <i class="far fa-clock"></i>
                        <span>{{searchRequest.Duration}} Night </span>
                      </div>
                      <div class="chk-tmng-three">
                        <label><b>Check Out</b></label>
                        <span>{{searchRequest.CheckOut}}</span>
                      </div>
                      <div class="chk-tmng-three pax-pd text-align-centre">
                        <label><b>Pax</b></label>
                        <span>{{SelectedRoom.NoOfAdult}} Adult(s), {{SelectedRoom.NoOfChild}} Child(s)</span></div>
                    </div>
                    <div class="details-pax row">

                      <div class="col-md-6"><label><b>Room Type</b></label><span> {{SelectedRoom.Type}}</span></div>
                      <div class="col-md-6" style="border-left: 1px solid #b5b0b0!important"> <label><b>Meal Plan</b></label><span>{{SelectedRoom.MealDesc}}</span></div>
                      
                     


                    </div>
                    <div class="high_lt">
                      <p class="mb-2">
                        <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>Free Cancellation</span>
                        <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>Free Wi-Fi</span>
                        <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>free wi-Fi</span>
                        <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>free wi-Fi</span>
                        <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>free wi-Fi</span>
                        <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>24 Hour Room Service</span><br />
                      </p>
                    </div>
                    <!--<div class="high_lt" *ngIf="hotel.Inclusions !=null && hotel.Inclusions.length>0">
    <p class="mb-2">
      <span class="text-success inclusionchk" *ngFor="let inc of hotel.Inclusions.slice(0,3)"><i class="fa-solid fa-check-double"></i>{{inc}}</span><br />
    </p>
  </div>-->
                  </div>
                  <!--extra info-->
                </div>
              </div>

            </div>

          </div>
        </div>
        <!-- End Of Flight Details -->
        <!-- Travellers Details -->
        <!-- Traveller Details Form -->
        <div class="traveller-card-cust-pax mt-5">
          <div class="traveller-header-cust-pax d-flex align-items-center justify-content-between">
            <div class="header-1"><i class="bi bi-person-circle"></i> Travellers Details</div>
            <div class="header-2">
              <i class="fa-regular fa-address-card"></i> Name should be same as in
              Identity Proof
            </div>

          </div>
          <div class="pax-contact contact-info-pax">
            <h5>Contact Information</h5>
            <p>
              <strong>Important!</strong> Provide your valid email and phone to receive e-ticket and relevant
              messages.
            </p>
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label for="email" class="form-label">
                  Email Address <span class="text-danger">*</span>
                </label>
                <input type="email" class="form-control" id="email"
                       placeholder="Enter your full email address" required>
              </div>
              <div class="col-12 col-md-6">
                <label for="mobile" class="form-label">Mobile <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text">+91</span>
                  <input type="tel" class="form-control" id="mobile" placeholder="Mobile No" required>
                </div>
              </div>
            </div>
            <div class="form-check mt-3">
              <input class="form-check-input" type="checkbox" id="marketingConsent" checked>
              <label class="form-check-label" for="marketingConsent">
                I agree to receive marketing emails, offers and promotions from {{companysname}}.
              </label>
            </div>
          </div>

          <div class="p-3 ">
            
            <div class="form-div mt-3">
              <div class="row g-2" *ngFor="let pax of bookHotelModel.BookingXML.PassengerDetails.Passenger;let ad=index;">
                <div class="col-12"
                     *ngIf="ad === 0 || bookHotelModel.BookingXML.PassengerDetails.Passenger[ad - 1].Room !== pax.Room">
                  <h6 class="adttl">Room {{ pax.Room }}</h6>
                </div>

                <div class="col-md-1 ad-txt">
                  <span><b>{{ pax.PaxType == "ADT" ? 'Adult' : 'Child' }}-{{ ad + 1 }}</b></span>
                </div>
                <div class="col-md-2">
                  <label class="form-label">Title <span style="color: #ed1300">*</span></label>
                  <select class="form-select ddlheight" id="Title_{{ad}}" name="Title_{{ad}}" [(ngModel)]="bookHotelModel.BookingXML.PassengerDetails.Passenger[ad].Title" #title="ngModel" [ngClass]="{'is-invalid': bookForm.submitted &&  title.invalid }" required>
                    <option selected value="">Select</option>
                    <option value="Mr">Mr.</option>
                    <option value="Mrs">Mrs.</option>
                    <option value="Ms">Ms.</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">First Name <span style="color: #ed1300">*</span></label>
                  <input [(ngModel)]="bookHotelModel.BookingXML.PassengerDetails.Passenger[ad].FirstName"
                         class="form-control" id="FirstName_{{ad}}" name="FirstName_{{ad}}"
                         pattern="[a-zA-Z][a-zA-Z ]+" #firstname="ngModel" [ngClass]="{'is-invalid': bookForm.submitted &&  firstname.invalid }" required maxlength="25" type="text">
                </div>
                <div class="col-md-3">
                  <label class="form-label">Middle Name</label>
                  <input [(ngModel)]="bookHotelModel.BookingXML.PassengerDetails.Passenger[ad].MiddleName" class="form-control" id="Middlename_{{ad}}" name="Middlename_{{ad}}"
                         pattern="[a-zA-Z][a-zA-Z ]+" maxlength="25"
                         type="text">
                </div>
                <div class="col-md-3">
                  <label class="form-label">Last Name <span style="color: #ed1300">*</span></label>
                  <input [(ngModel)]="bookHotelModel.BookingXML.PassengerDetails.Passenger[ad].LastName"
                         class="form-control" id="LastName_{{ad}}" name="LastName_{{ad}}"
                         pattern="[a-zA-Z][a-zA-Z ]+" #lastname="ngModel" [ngClass]="{'is-invalid': bookForm.submitted &&  lastname.invalid }" required maxlength="25" type="text">
                </div>
              </div>
              <div class="row g-2 mt-2">
                <div class="col-md-12">
                  <label class="form-label">Special Request (if any)</label>
                  <textarea class="form-control" cols="20" id="" name="SpecialRequest" rows="2"
                            autocomplete="off"></textarea>
             </div>
             </div>
            </div>

            <a href="#"  class=" passport-info">&nbsp;</a>
          </div>

        </div>
        <!-- Traveller Details Final -->
        <div class="traveller-card-fnl-detail mt-5 mb-5" *ngIf="SelectedRoom">
          <div class="card-header-custom-fnl-detail d-flex justify-content-between align-items-center">
            <span>Cancellation Policy</span>
          </div>
          <ul class="booking-p">
            <li *ngFor="let Policy of SelectedRoom.CancellationPolicy.Policies.Policy;">
              If you cancel booking between {{Policy.DateFrom}} To
              {{Policy.DateTo}} then Cancellation Charges will be
              {{Policy.Currency}} {{Policy.GrossPrice}}
            </li>
            <li class="mb-10 ml-16">
              Note:- In case of multiple cancellation policies with same date range, after cancellation; highest cancellation charges will be applicable.
            </li>
          </ul>
        </div>
        <!-- End Of Traveller Detail Final-->

      </div>

      <!-- Right Column -->
      <div class="col-lg-3">
        <div class="sidebar-box">
          <!-- Price Summary -->
          <div class="price-summary-pax d-flex align-items-center">
            <h3>Price Summary</h3>
            <div class="icons">
              <span>👤</span><span>🍴</span><span>🍼</span>
            </div>
          </div>
          <div class="details-pax">
            <span><strong>{{SelectedRoom.NoOfRoom}} Room x {{searchRequest.Duration}} Night</strong><strong>{{sharedServiceService.currencySymbol}} {{(SelectedRoom.GrossPrice)*(sharedServiceService.currencyConversionRate) | number:'1.2-2'}}</strong></span>
            <span>Coupon Discount<strong style="color: green;">-{{sharedServiceService.currencySymbol}} {{CoupanAmount}}</strong></span>
            <span class="total">Grand Total<strong>{{sharedServiceService.currencySymbol}}{{(SelectedRoom.GrossPrice)*(sharedServiceService.currencyConversionRate) | number:'1.2-2'}}</strong></span>
          </div>
        </div>

        <div class="sidebar-box">
          <!-- Offers & Promo Code -->
          <div class="promo-code-pax">
            <h3>Offers & Promo Code <span class="icon">🎁</span></h3>
          </div>
          <div class="promo-box-content">
            <div class="code">
              <input type="text" class="form-control" placeholder="Enter promocode" id="coupanCode" name="coupanCode" value="" #coupanCode>
              <a class="coupon-apply" (click)="ApplyCoupanCode(coupanCode.value)">Apply</a>
            </div>
            <div style="color:red" *ngIf="coupanStatus=='NOTEXIST'|| coupanStatus=='EXPIRED' || coupanStatusText=='Enter Coupon'">{{coupanStatusText}}</div>
            <div class="success" *ngIf="coupanStatus=='SUCCESS'">{{coupanStatusText}}  <a *ngIf="coupanStatus=='SUCCESS' && IsCoupanAmount"><span style="color:red ! important" class="chk-r" (click)="RemoveCoupanCode()">Delete</span></a></div>


            <div class="options-pax ">
              <label class=" align-items-center current-promo">
                <input type="radio" name="promo" checked>
                <div class="offer-box">
                  BOOKNOW
                </div>
                <div class="offer-box-text1">Get Rs.1250 OFF on your flight booking.</div>
              </label>
              <label class="d-flex align-items-center">
                <input type="radio" name="promo">
                <div class="offer-box">
                  DELIGHT
                </div>

                <div class="offer-box-text1">
                  Win a Flight, Hotel stay, and Holiday voucher worth INR
                  4000.
                </div>
              </label>
              <label class="d-flex align-items-center">
                <input type="radio" name="promo">
                <div class="offer-box">
                  EMTNCF
                </div>
                <div class="offer-box-text1"> ZERO Convenience Fees</div>

              </label>
            </div>
          </div>
        </div>

        <!-- Continue Booking -->
        <div class="sidebar-box mt-4">
          <!-- Payment gateway -->
          <div class="price-summary-pax d-flex align-items-center">
            <h3>Payment GateWay</h3>

          </div>
          <div class="card-pax">
            <div class="radio-group-pax mb-4">

              <div class="form-check">
                <input type="radio" class="form-check-input radiopmt" name="paymentgateway" id="CCAvenue" [(ngModel)]="PaymentGateway" value="CCAvenue" />
                <label class="form-check-label">
                  <img src="assets/images/Gateway/CCAvenue.png" alt="CCAvenue">

                </label>
              </div>
              <div class="form-check" *ngIf="IsProdution!=true">
                <input class="form-check-input radiopmt" type="radio" name="paymentgateway" id="PAYTM" [(ngModel)]="PaymentGateway" value="PAYTM">
                <label class="form-check-label" for="paytm">
                  <img src="assets/images/Gateway/PAYTM.PNG" alt="Paytm">
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input radiopmt" type="radio" name="paymentgateway" id="PAYU" [(ngModel)]="PaymentGateway" value="PAYU">
                <label class="form-check-label" for="payu">
                  <img src="assets/images/Gateway/PAYU.PNG" alt="PayU">
                </label>
              </div>
              <!--<div class="form-check" *ngIf="IsProdution!=true">
                <input class="form-check-input" type="radio" name="paymentgateway" id="rdATOMINT" [(ngModel)]="PaymentGateway" value="ATOMINT">
                <label class="form-check-label" for="atomInt">
                  <img src="assets/images/Gateway/ATOM-INT.png" alt="Atom INT">
                </label>
              </div>
              <div class="form-check" *ngIf="IsProdution!=true">
                <input class="form-check-input" type="radio" name="paymentgateway" id="rdATOMDOM" [(ngModel)]="PaymentGateway" value="ATOMDOM">
                <label class="form-check-label" for="atomInt">
                  <img src="assets/images/Gateway/ATOM-DOM.png" alt="Atom Domestic">
                </label>
              </div>-->
              <div class="form-check">
                <input class="form-check-input radiopmt" type="radio" name="paymentgateway" id="EASEBUZZ" [(ngModel)]="PaymentGateway" value="EASEBUZZ">
                <label class="form-check-label" for="Easebuzz">
                  <img src="assets/images/Gateway/Easebuzz_Logo.jpg" alt="Ease buzz">
                  <!--<span class="service-charge-pax">(Service Charge Applicable)</span>-->
                </label>
              </div>
            </div>
            <button type="submit" class="btn proceed-btn-pax w-100">Proceed to Pay</button>
            <p class="terms-pax">
              <input class="form-check-input" type="checkbox" id="termandcondition" checked> By booking with {{companysname}}, you agree to our <a href="javascript:void(0)" (click)="TermConditionpopup(termcondition)">
                Terms and
                Conditions
              </a>.
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
  </form>
  <app-loader *ngIf="loader"></app-loader>
  <app-loader *ngIf="loadercoupon"></app-loader>
  <!-- session expired popup start -->
  <div class="prc-change-over " [ngClass]="IsSessionPopUp ? 'session-expire-popup': 'session-expire-popup-h'">
    <div class="prc-change-wrap">
      <div class="close-change-hotel" routerLink="/hotel"><em class="fa fa-close"></em></div>
      <div class="sess-exp">
        <div class="change-hotel0img">
          <img style="width:80px;height:80px;"
               src="assets/images/logo-main.png" alt="">
        </div>
        <div class="sess-title">Your session has expired</div>
        <div class="sess-det">
          Please refresh the page. Don't worry, we keep all your
          filters and breakdowns in place
        </div>
        <div class="ref-res"><a style="color: #fff;" routerLink="/hotel">Home</a></div>
      </div>
    </div>
  </div>
  <ng-template #termcondition>

    <div class="modal-header">
      <h4 class="modal-title pull-left">Terms and conditions</h4>
      <button type="button" class="close pull-right" style="background: none;" aria-label="Close"
              (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>        
        <ul class="booking-p">
          <li>
            As per government regulations, every guest above 18 years must carry a valid photo ID. Accepted
            identification proofs include Driving License, Voter ID, Passport, and Ration Card. Guests without
            valid ID will not be allowed to check in.
          </li>
          <li>
            The booking platform will not be responsible for denied check-in due to invalid or missing ID proof.
          </li>
          <li>
            The primary guest checking in must be at least 18 years old. Children accompanying adults should be
            between 1 and 12 yeart.
          </li>
          <li>
            Guests will be charged for extra beds, meals, and other facilities not included in the booking.
            Charges may vary by hotel.
          </li>
          <li>
            If an extra bed is included in your booking, it may be provided as a folding cot or mattress,
            depending on hotel policy.
          </li>
          <li>
            Check-in and check-out times vary by hotel. Please refer to the confirmation voucher. For early
            check-in or late check-out, contact the hotel directly for availability and applicable charges.
          </li>
          <li>
            The room tariff is inclusive of all applicable taxes unless specified otherwise. Charges for
            additional services such as room service, mini bar, snacks, and phone calls are to be settled
            directly with the hotel during check-out.
          </li>
          <li>
            If a hotel denies accommodation to guests posing as a 'couple' without valid ID, the platform will
            not be responsible and no refund will be provided in such cases.
          </li>
          <li>
            Some hotels may deny accommodation to local residents. Guests are advised to confirm this with the
            hotel in advance. No refund will be issued for check-in denied on these grounds.
          </li>
          <li>
            Modifications are subject to availability and hotel policies. Guests may be charged applicable
            modification or cancellation fees.
          </li>
        </ul>
</div>
    </div>
  </ng-template>
  <!-- session expired popup end -->
